module.exports = __webpack_public_path__ + "img/T1A_xh_13.91dc745a.png";